module.exports = __webpack_public_path__ + "media/images/application/choose-price/poulpe-09-e700662b8e797be40aa1cbf07ca74156.svg";